import React from 'react'
import "./arrowButton.scss"
import '../../../styles/fontSizes.scss'

// type puede ser = left, right, down, up, right--2
const ArrowButton = ({type, textSize, handleClick}) =>{
    return(
        <>
            {type == "right--2"? 
            <button onClick = {handleClick} className = {`arrow-button arrow-button--right-2 font-size--${textSize}`}>
            </button>
            :
            <button onClick = {handleClick} className = {`arrow-button arrow-button--${type} font-size--${textSize}`}></button>
            }
        </>
    )
}

export default ArrowButton;